<div class="dots" [class.dots--basic]="isBasic">
  <div class="dots__inner">
    <div
      class="dots__item"
      *ngFor="let dot of dots; trackBy: trackByFn"
      [style.left]="dot.index * (6 + 8) + 'px'"
      [style.transform]="transformX"
    >
      <div
        class="dot"
        [class.dot--active]="dot.index === currentIndex"
        [class.dot--is-hidden]="dot.isHidden"
        [class.dot--is-small]="dot.isSmall"
        [class.dot--is-tiny]="dot.isTiny"
        (click)="goToImage(dot.index)"
      ></div>
    </div>
  </div>
</div>
